<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            prop="inviterShareCode"
            label="邀请人的分享码"
            width="180">
    </el-table-column>
    <el-table-column
            prop="username"
            label="昵称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="registerTime"
            label="注册时间"
            width="180">
    </el-table-column>
<!--    <el-table-column-->
<!--            prop="endReceiveDate"-->
<!--            label="最终领取期限"-->
<!--            width="180">-->
<!--    </el-table-column>-->
    <el-table-column
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "ShareTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$emit("view",id)
      },
      update(id){
        this.$emit("update",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
